import {
  collection,
  doc,
  getDocs,
  getDoc,
  addDoc,
  updateDoc,
  deleteDoc,
  query,
  orderBy,
  serverTimestamp,
  Timestamp,
} from "firebase/firestore";
import { db } from "@/lib/firebase";
import { COLLECTIONS } from "@/constants/firestoreCollections";

function normalizeDates(data: Record<string, unknown>): Record<string, unknown> {
  const result = { ...data };
  for (const key of ["createdAt", "updatedAt", "startsAt", "endsAt"]) {
    const val = result[key];
    if (val && typeof (val as { toDate?: () => Date }).toDate === "function") {
      result[key] = (val as Timestamp).toDate();
    }
  }
  return result;
}

export async function getAllAnnouncements() {
  const q = query(
    collection(db, COLLECTIONS.ANNOUNCEMENTS),
    orderBy("createdAt", "desc")
  );
  const snapshot = await getDocs(q);
  return snapshot.docs.map((d) => ({
    id: d.id,
    ...normalizeDates(d.data()),
  }));
}

export async function getAnnouncementById(id: string) {
  const ref = doc(db, COLLECTIONS.ANNOUNCEMENTS, id);
  const snap = await getDoc(ref);
  if (!snap.exists()) return null;
  return { id: snap.id, ...normalizeDates(snap.data()) };
}

export async function createAnnouncement(data: Record<string, unknown>) {
  const docRef = await addDoc(collection(db, COLLECTIONS.ANNOUNCEMENTS), {
    ...data,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });
  return { id: docRef.id };
}

export async function updateAnnouncement(
  id: string,
  data: Record<string, unknown>
) {
  const ref = doc(db, COLLECTIONS.ANNOUNCEMENTS, id);
  await updateDoc(ref, {
    ...data,
    updatedAt: serverTimestamp(),
  });
}

export async function deleteAnnouncement(id: string) {
  await deleteDoc(doc(db, COLLECTIONS.ANNOUNCEMENTS, id));
}

export async function toggleAnnouncementActive(id: string, isActive: boolean) {
  const ref = doc(db, COLLECTIONS.ANNOUNCEMENTS, id);
  await updateDoc(ref, {
    isActive,
    updatedAt: serverTimestamp(),
  });
}
